import PropTypes from "prop-types"
import NameArrayShape from "./NameArrayShape"

const ColumnLineChartShape = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  series: PropTypes.arrayOf(PropTypes.shape(NameArrayShape)).isRequired,
}

export default ColumnLineChartShape



// WEBPACK FOOTER //
// ./src/state/shapes/ColumnLineChartShape.js